import { render, staticRenderFns } from "./EmailStarter.vue?vue&type=template&id=5f184964&scoped=true&"
import script from "./EmailStarter.vue?vue&type=script&lang=js&"
export * from "./EmailStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f184964",
  null
  
)

export default component.exports